// extracted by mini-css-extract-plugin
export var pageTitle_decoration_1 = "contact-page-title-module--pageTitle_decoration_1--3Vrvp";